<style scoped  lang="less">
.pickerBox{
  height: 100%; width: 100%; position: relative;
  .click{position: absolute;left: 0;top:0;width: 100%;height: 100%;overflow: hidden;z-index: 9999;}
  overflow: hidden;position: relative;
  height: 100%; width: 100%;
  .baseSelect{width: 100%;height: 100%; opacity : 0 !important;z-index: 1;}
  .p_time{white-space: nowrap;position: absolute;left: 0;top:0;width: 100%;height: 100%;z-index: 11;}
  .el-select {z-index: 1;}
  .el-input--suffix{height: 100% !important;  }
  .pc_box{position: absolute;left: 0;top:0;width: 100%;height: 100%;z-index: 1;overflow: hidden;}
}

</style>
<template>
  <div>
   
    <!-- v-if="(screenWidth>750?true:false)" -->
    <div class="pickerBox">
        <div class="click" @click="openPicker"></div>
        <p class="p_time">{{optionsText}}</p>
        <div class="pc_box">
          <!-- @pick="handleTimePick" -->
          <el-select class="baseSelect" v-model="selectData" ref="mySelect"  :visible.sync="selectVisible">
            <el-option
              v-for="(item, index) in options"
              :key="item.value"
              :label="item.name"
              :value="item" 
              @click.native ="onConfirm(item,index)"
            >
            </el-option>
          </el-select>
        </div>
        <div class="web_box">
        </div>
    </div>  
    <van-popup v-model="show" position="bottom"  get-container="#app" > 
      <van-picker
        title=""
        show-toolbar
        :columns="options"
        value-key="name"
        :default-index="selectIndex" 
        @confirm="onConfirm"
        @cancel="onCancel"
        @change="onChange" 
        :confirm-button-text="this.langConfig.txtLang[this.langConfig.curLang]['CONFIRM']"
        :cancel-button-text="this.langConfig.txtLang[this.langConfig.curLang]['CANCEL']"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return { 
      // options: [{
      //   value: 'a1',
      //   name: '黄金糕'
      // }, {
      //   value: 'a2',
      //   name: '双皮奶'
      // }, {
      //   value: 'a3',
      //   name: '蚵仔煎'
      // }, {
      //   value: 'a4',
      //   name: '龙须面'
      // }, {
      //   value: 'a5',
      //   name: '北京烤鸭'
      // }],
      optionsValue: '', 
      optionsText:'',//显示名字 
      selectIndex:0,
      selectData:{},
      show: false,
      selectVisible:false,
    };
  }, 
  watch: {
    options(newValue) {
      //console.log('optionsbianhuala.',newValue);
      //console.log('options12312312.',this.options);
      var newValue_l=newValue.length;
      var selectIndex=JSON.parse(JSON.stringify(this.selectIndex))
      if(selectIndex>newValue_l*1-1){
        selectIndex=0;
      }
      this.setValue(selectIndex)
      // // 当 parentData 改变时，更新子组件的数据
      // this.$refs.child.updateData(newValue);
    }
  },
  methods: { 
    openPicker2(){
      console.log('optionsValue222',this.optionsValue);
    },
    onConfirm(value,index) {
      console.log('value11',value,index); 
      this.selectData=value
      this.selectIndex=index;
      this.optionsText=value.name
      this.show=false;
    
      this.$emit('changePicker',this.getValue())

     
      //Toast(`当前值1：${value}, 当前索引：${index}`);
    },
    onChange(picker, value, index) {
      console.log(`当前值2：${value}, 当前索引：${index}`);
    },
    onCancel() {
      this.show=false;
    },
    //=================
    openPicker(){ 
      //this.show = true;
      if(this.screenWidth>750){//PC
        this.show = false; 
        if(this.$refs.mySelect){
          this.$refs.mySelect.toggleMenu(true);
        }
      }else{//web
        this.show = true;
      } 
    },
    closePicker(val=false){
      // console.log('this.$refs.mySelect',this.$refs.mySelect);
      // if(this.$refs.mySelect){
      //     this.$refs.mySelect.close(val);
      //   }
      if(val==true){
        this.$refs.mySelect.toggleMenu(true);
      }else{
        this.selectVisible=false;
      }
    }
    ,
    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.screenWidth = window.innerWidth;
      }
    },
    //设置
    setValue(val){
      var options=JSON.parse(JSON.stringify(this.options))
      var v=options[val];
      this.selectData=v
      this.selectIndex=val;
      this.optionsText=v.name ;
      return v;
    },
    //获取
    getValue(val){ 
      console.log('this.selectDatathis.selectData',this.selectData);
      var selectData=JSON.parse(JSON.stringify(this.selectData))
      var selectIndex=JSON.parse(JSON.stringify(this.selectIndex))
      selectData['index']=selectIndex;
      console.log('selectData',selectData);
      return selectData;
    }
  },
  created() {
    // 初始化
    if(typeof window!='undefined'){
      this.screenWidth = window.innerWidth;
    }
    //this.setTime();
  
  },
  mounted() {
    if(typeof window!='undefined'){
      window.addEventListener('resize', this.handleResize);
    }
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  props: {
    options:{
      type:Array,
      default:() =>[],
    },
    
  }
};
</script>



// WEBPACK FOOTER //
// ./src/components/basePicker.vue